import React from 'react'
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import AllNotification from '../AllNotification'

function AllNotificationLayout() {
  return (
    <>
      <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Container maxWidth="lg" sx={{ mt: 12, mb: 4 }}>
           <AllNotification/>
          </Container>
        </Box>
    </>
  )
}

export default AllNotificationLayout
